let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iD08t")).then(() => parcelRequire('fCdHk'));